"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- COPY FIELD : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'CopyField',
  props: {
    name: {
      type: 'string',
      default: 'copyfield'
    },
    defaultValue: {
      type: 'string',
      default: 'some default value here'
    },
    nowrap: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    handleCopy: {
      type: 'function',
      default: function _default(fieldVal, e) {
        return console.log(fieldVal, e);
      }
    },
    height: {
      type: 'string',
      default: 'inline',
      options: ['inline', 'short', 'medium', 'tall']
    },
    readyOnly: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    margin: {
      type: 'string',
      default: '0px'
    },
    scrollbarColor: {
      type: 'string',
      default: 'transparent'
    },
    ctaVariant: {
      type: 'string',
      default: 'primary',
      options: ['primary', 'secondary', 'normal', 'system', 'disabled', 'action', 'delete', 'combination', 'control', 'none']
    },
    icon: {
      type: 'string',
      default: 'clipboard'
    },
    iconRight: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    ctaPosition: {
      type: 'string',
      default: 'inline',
      options: ['inline', 'block']
    },
    buttonDisabled: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    fieldDisabled: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    fieldType: {
      type: 'string',
      default: 'textarea',
      options: ['textarea', 'text']
    },
    link: {
      type: 'object',
      default: {
        name: 'link',
        text: 'Link',
        url: 'https://insticator.com'
      }
    },
    handleLinkClick: {
      type: 'function',
      default: function _default() {
        return console.log('link clicked');
      }
    }
  }
};
exports.default = _default2;